import React from 'react';
import { connect } from 'react-redux';
import { mapStateToProps, mapDispatchToProps } from '../Store';
import Layout from '../components/layouts/Layout';
import SEO from '../components/seo';
import EntryInner from '../components/enter/entry_inner';
import Entries from '../components/enter/entries';
import { LoginInner } from './login';
import ContentLoading from '../components/widgets/content_loading';

import page_header from '../../static/assets/images/headers/enter-now-header.png';

export const Entry = ({ entry, drawTicket, user, notification, game, animation, actions }) => {
    const { loggedIn } = user;
    const { gameOver } = drawTicket;

    if (!loggedIn) {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title='Enter Now' />
                <div className='content-container enter'>
                    <div className='row'>
                        <div className='col-md-10 col-md-offset-1'>
                            <ContentLoading hasIcon={false} loadedAction='getPlayerData'>
                                <LoginInner user={user} actions={actions} />
                            </ContentLoading>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    } else {
        return (
            <Layout user={user} notification={notification} actions={actions}>
                <SEO title='Enter Now' />
                <div className='content-container enter'>
                    <div className='row'>
                        <div className='col-md-10 col-md-offset-1'>
                            <h1 className='sr-only'>Enter Now</h1>
                            <img alt='Enter Now' className='img-responsive center-block header-image' src={page_header} />

                            <ContentLoading hasIcon={true} loadedAction='getPlayerData'>
                                <EntryText
                                    user={user}
                                    drawTicket={drawTicket}
                                    entry={entry}
                                    game={game}
                                    animation={animation}
                                    actions={actions}
                                    gameOver={gameOver}
                                />
                                <Entries entry={entry} actions={actions} />
                            </ContentLoading>
                        </div>
                    </div>
                </div>
            </Layout>
        );
    }
};

const EntryText = ({ entry, user, drawTicket, game, actions, animation, gameOver }) => {
    if (gameOver) {
        return (
            <div className='entry-over'>
                <h2 className='text-center'>Thank You For Playing!</h2>
                <h3 className='text-center uppercase'>The entry period for this promotion has now ended.</h3>
            </div>
        );
    } else {
        return <EntryInner entry={entry} drawTicket={drawTicket} user={user} game={game} animation={animation} actions={actions} />;
    }
};

export default connect(mapStateToProps, mapDispatchToProps)(Entry);
